// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6036":"css/admin-app.6706","8100":"css/app.6706"}[chunkId] + ".css";
};